module.exports = __webpack_public_path__ + "files/7243979c3b69f0f64d4a1177c3a29df6.png";